// extracted by mini-css-extract-plugin
module.exports = {"Links":"links_Links__So_Tl","Link":"links_Link__TNWcV","Container":"links_Container__stbed","Background":"links_Background__zbK2I"};